import { render, staticRenderFns } from "./microphone.vue?vue&type=template&id=1edc2b6c"
import script from "./microphone.vue?vue&type=script&lang=js"
export * from "./microphone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports